import { richTextHasContent } from "./richTextHasContent"

/**
 * CRJobTextField always renders the single job field configured in
 * `config.general.text.offerField.value`. When the ATS delivers nothing for that field,
 * hide the whole module rather than leave an empty header-only section (JET-2147).
 */
export function jobTextFieldHasContent(module: ContentModule, job: FlatJob | undefined): boolean {
  if (!job)
    return false

  const field = (module?.config as OfferFieldConfig | undefined)
    ?.general?.text?.offerField?.value

  if (!field)
    return false

  // language_skills is the one offer field that arrives as an array rather than rich text.
  if (field === "language_skills") {
    const skills = (job as { language_skills?: unknown[] }).language_skills
    return Array.isArray(skills) && skills.length > 0
  }

  return richTextHasContent((job as Record<string, unknown>)[field])
}
